import {manageAttentionMessage} from './modules/attention-message';

window.addEventListener('DOMContentLoaded', () => {
  manageAttentionMessage();
});
